import {connect} from 'react-redux';
import Choice from './Choice';
import {selectAnswer} from '../../../../../actions/exam';

const mapStateToProps = state => ({

});

const mapDispatchToProps = (dispatch, ownProps) => ({
  selectAnswer: choice => dispatch(selectAnswer(choice))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Choice);
